import { combineReducers } from 'redux';
import translationReducer from './translationReducer';
import masterdataReducer from './masterdata';

export default combineReducers({
    translation: translationReducer,
    masterdata: masterdataReducer,
});
